import { type PropsWithChildren } from 'react';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@components/ui/alert-dialog';
import { type IDeleteFolderInputData } from '@services/folders/dtos/deleteFolder/InputData';
import { type IDeleteNoteInputData } from '@services/notes/dtos/deleteNote/InputData';

interface IProps extends PropsWithChildren {
  id: string;
  onDeleteFolder?: (data: IDeleteFolderInputData) => Promise<void>;
  onDeleteNote?: (data: IDeleteNoteInputData) => Promise<void>;
}

function DeleteAlertDialog({
  children,
  id,
  onDeleteFolder,
  onDeleteNote,
}: IProps) {
  const handleRemove = () => {
    if (onDeleteFolder) {
      onDeleteFolder({
        id,
      });
    }
    if (onDeleteNote) {
      onDeleteNote({
        id,
      });
    }
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>{children}</AlertDialogTrigger>
      <AlertDialogContent
        className="sm:max-w-[425px]"
        onClick={(e) => e.stopPropagation()}>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-primary">Atenção!</AlertDialogTitle>
          <AlertDialogDescription className="text-foreground">
            Tem certeza que deseja excluir esse item?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="cursor-pointer">
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction
            className="cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              handleRemove();
            }}>
            Excluir
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default DeleteAlertDialog;
